
import { useState } from 'react';

export default function WechatFloat() {
  const [showQR, setShowQR] = useState(false);

  return (
    <>
      {/* 全屏遮罩层 */}
      {showQR && (
        <div 
          className="fixed inset-0 md:bg-transparent bg-black/50 z-[9998]"
          onClick={() => setShowQR(false)}
        />
      )}

      {/* 悬浮容器 */}
      <div className="fixed right-4 sm:right-6 top-[75%] -translate-y-1/2 z-[9999]">
        {/* 二维码浮层 */}
        {showQR && (
          <div 
            className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 md:fixed md:left-auto md:top-1/2 md:-translate-y-1/2 md:right-[5.5rem] sm:md:right-[6.5rem] md:translate-x-0 bg-white rounded-xl shadow-2xl border border-gray-100 p-4 sm:p-5 w-[280px] sm:w-[240px]"
            style={{ animation: 'fadeIn 0.2s ease-out' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center mb-3">
              <span className="text-sm sm:text-base font-semibold text-gray-800">微信扫码咨询</span>
            </div>
            <div className="bg-gray-50 rounded-lg p-3">
              <img
                src="https://static.readdy.ai/image/c9656b810d2c6cc0a8672cac16e7cf96/e7f95b852e2d7fc033ed8e2278921757.png"
                alt="微信二维码"
                className="w-40 h-40 sm:w-32 sm:h-32 object-contain mx-auto"
              />
            </div>
            <p className="text-xs sm:text-sm text-gray-400 text-center mt-2">
              专属顾问为您服务
            </p>
            {/* 移动端关闭按钮 */}
            <button
              onClick={() => setShowQR(false)}
              className="md:hidden absolute top-2 right-2 w-7 h-7 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        )}

        {/* 悬浮按钮 */}
        <div 
          className="flex flex-col items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-white text-[#0066ff] rounded-full shadow-lg border border-gray-100 cursor-pointer hover:shadow-xl hover:scale-105 transition-all group"
          onClick={(e) => {
            e.stopPropagation();
            setShowQR(!showQR);
          }}
        >
          <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
            <i className="ri-wechat-fill text-xl sm:text-2xl text-[#07C160]"></i>
          </div>
          <span className="text-[9px] sm:text-[10px] font-medium text-[#0066ff] mt-0.5">咨询</span>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
}